import React from 'react';
import './util/config';
import ReactDOM from 'react-dom/client';
import { PostHogProvider } from 'posthog-js/react';
import * as Sentry from '@sentry/react';
import App from './pages/_app';
import * as serviceWorker from './serviceWorker';
import { getPosthogConfig, isAnalyticsEnabled } from './config/analytics';
import packageJson from '../package.json';

// Print the current version to the console
console.log('Current version:', packageJson.version);

const root = ReactDOM.createRoot(document.getElementById('root'));

// Only wrap with PostHogProvider if analytics is properly configured
const app = isAnalyticsEnabled() ? (
  <PostHogProvider {...getPosthogConfig()}>
    <App />
  </PostHogProvider>
) : (
  <App />
);

root.render(app);

// Defer Sentry initialization until after the app has mounted
// This prevents interference with Google API script loading during early initialization
// and avoids race conditions with Firebase Auth initialization
setTimeout(() => {
  const sentryDsn = process.env.REACT_APP_PUBLIC_SENTRY_DSN;
  if (sentryDsn) {
    Sentry.init({
      dsn: sentryDsn,
      // Setting this option to true will send default PII data to Sentry.
      // For example, automatic IP address collection on events
      sendDefaultPii: true
    });
  }
}, 1000);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
